import React from "react"
import {useLightbox, useLocal} from "../AppContext"
import {iconCloseThin} from "../Helper/Icons"
import style from "./Lightbox.css"
import {Button} from "./Button"

export const Lightbox = ({type, children}) => {
    const lightbox = useLightbox()
    const local = useLocal()

    return <div className={style.container} style={{zIndex: lightbox.getZIndex(type)}}>
        <div className={style.head}>
            <div className={style.close}>
                <div className={style.label}><span>{local.__("zurück zum Raumplaner")}</span></div>
                <div className={style.icon} onClick={lightbox.close}>{iconCloseThin}</div>
            </div>
        </div>
        <div className={style.main}>
            {children}
        </div>
        <div className={style.foot}>
            <Button onClick={lightbox.close}>{local.__("zurück zum Raumplaner")}</Button>
        </div>
    </div>
}
